import { CIRCLE_DATA, BUBBLEUSERID, MENU_STATUS } from '../actions/fetch_topusers';

 export const circleData = (state = [], action) => {
  switch (action.type) {
    case CIRCLE_DATA:
    	return  action.payload; 
    default:
      return state
  }
}

export const bubbleUserId = (state = [], action) => {
  switch (action.type) {
    case BUBBLEUSERID:
    	return action.payload
    default:
      return state
  }
}

export const menuStatus = (state = false, action) => {
  switch (action.type) {
    case MENU_STATUS:
      return action.payload
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_topusers.js